(() => {
  angular
    .module('app')
    .controller(
      'host.views.corporates.createEdit.creditLimit.creditLimitHistory',
      CreditLimitHistoryModalController
    );

  CreditLimitHistoryModalController.$inject = [
    '$uibModalInstance',
    'abp.services.app.creditLimit',
    'Hms.CreditLimits.CreditLimitChangeType',
    'corporateId',
    'currencyCode',
  ];

  function CreditLimitHistoryModalController(
    $uibModalInstance,
    creditLimitSvc,
    enumCreditLimitChangeType,
    corporateId,
    currencyCode
  ) {
    const vm = this;

    // Same colours as the epic's design: a revoke stands out, an expiry does not.

    const changeTypeLabelClasses = {
      [enumCreditLimitChangeType.PermanentChange.id]: 'label-default',
      [enumCreditLimitChangeType.TemporaryGranted.id]: 'label-info',
      [enumCreditLimitChangeType.TemporaryExpired.id]: 'label-default',
      [enumCreditLimitChangeType.TemporaryRevoked.id]: 'label-danger',
    };

    vm.loading = 0;
    vm.currencyCode = currencyCode;
    vm.items = [];

    vm.getChangeTypeName = getChangeTypeName;
    vm.getChangeTypeLabelClass = getChangeTypeLabelClass;
    vm.cancel = cancel;

    init();

    function init() {
      getCreditLimitHistory();
    }

    // Already newest first. A grant's granted row and its expired or revoked row share its
    // reference number. The actor is "System" for the sweep, and nobody for a change copied from
    // the old screen that did not record who made it.

    function getCreditLimitHistory() {
      vm.loading += 1;
      creditLimitSvc
        .getCreditLimitHistory({ id: corporateId })
        .success((data) => {
          vm.items = _.map(data.items, (item) => _.assign({}, item, { actor: getActor(item) }));
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getActor(item) {
      return item.isChangedBySystem ? App.localize('System') : item.changedByName || '';
    }

    function getChangeTypeName(changeType) {
      const type = _.find(enumCreditLimitChangeType.values, { id: changeType });
      return type ? type.name : '';
    }

    function getChangeTypeLabelClass(changeType) {
      return changeTypeLabelClasses[changeType] || 'label-default';
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
